import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { XCircle, Home, RotateCcw, AlertTriangle } from 'lucide-react';
import { KioskScreen } from '../../components/kiosk/KioskScreen';
export function PaymentFailed() {
  const navigate = useNavigate();
  const location = useLocation();
  const reason = (location.state as any)?.reason || 'OTP failed অথবা পেমেন্ট সম্পন্ন করা যায়নি';
  return <KioskScreen showFooter={false} data-id="element-523">
      <main className="flex-1 min-h-0 flex items-center justify-center px-6" data-id="element-524">
        <div className="w-full max-w-md bg-white/95 backdrop-blur-md rounded-3xl shadow-xl border border-white/80 p-8 text-center" data-id="element-525">
          <XCircle className="w-20 h-20 text-destructive mx-auto mb-4" data-id="element-526" />

          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2" data-id="element-527">
            পেমেন্ট ব্যর্থ হয়েছে
          </h2>
          <p className="text-slate-600 mb-5" data-id="element-528">
            দুঃখিত, আপনার পেমেন্ট সম্পন্ন করা সম্ভব হয়নি।
          </p>

          <div className="bg-destructive/5 border border-destructive/20 rounded-2xl p-3 mb-6 flex items-start gap-2 text-left" data-id="element-529">
            <AlertTriangle className="w-5 h-5 text-destructive shrink-0 mt-0.5" data-id="element-530" />
            <div data-id="element-531">
              <p className="text-xs text-slate-500 font-medium" data-id="element-532">
                সম্ভাব্য কারণ
              </p>
              <p className="text-sm font-medium text-slate-900" data-id="element-533">{reason}</p>
            </div>
          </div>

          <div className="space-y-2" data-id="element-534">
            <Button size="lg" className="w-full" onClick={() => navigate(-2)} data-id="element-535">
              <RotateCcw className="w-5 h-5 mr-2" data-id="element-536" />
              আবার চেষ্টা করুন
            </Button>
            <Button variant="outline" size="lg" className="w-full" onClick={() => navigate('/')} data-id="element-537">
              <Home className="w-5 h-5 mr-2" data-id="element-538" />
              হোমে ফিরে যান
            </Button>
          </div>
        </div>
      </main>
    </KioskScreen>;
}